module.exports = __webpack_public_path__ + "static/media/MF.bccee9bc.png";